import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-product-category",
  templateUrl: "./product-category.component.html",
  styleUrls: ["./product-category.component.scss"]
})
export class ProductCategoryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
